import React from 'react';

interface ObjectOverheadProps {}

export function ObjectOverhead(props: Readonly<ObjectOverheadProps>) {
	return (
		<svg width={90} height={90} viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_17222)">
				<mask
					id="a"
					x={58}
					y={2}
					width={27}
					height={32}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M58.617 8.977L74.82 2.86l9.26 24.527-16.202 6.117-9.26-24.527z" fill="#fff" />
				</mask>
				<g mask="url(#a)">
					<path
						fill="#71828F"
						d="M63.564 7.811l3.174-1.843 15.06 15.396-11.842 11.354-2.355.029L63.564 7.81z"
					/>
				</g>
				<mask
					id="b"
					x={49}
					y={2}
					width={33}
					height={34}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M49.93 11.023l22.426-8.466 9.388 24.868-22.425 8.467-9.39-24.869z" fill="#fff" />
				</mask>
				<g mask="url(#b)">
					<path d="M52.28 17.236L64.05 5.694l15.319 15.513-11.77 11.543-15.32-15.514z" fill="#71828F" />
				</g>
				<mask
					id="c"
					x={52}
					y={12}
					width={18}
					height={24}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M52.012 16.527l9.938-3.752 7.31 19.363-9.938 3.752-7.31-19.363z" fill="#fff" />
				</mask>
				<g mask="url(#c)">
					<path d="M52.284 17.235l1.267-1.242 15.394 15.411-1.342 1.344-15.32-15.513z" fill="#445662" />
				</g>
				<path
					fill="#CFCFCF"
					d="M67.915 32.82l1.737.015 11.59-11.21-15.19-15.833-2.008-.096c5.121 5.243 10.243 10.485 15.363 15.729L67.915 32.82z"
				/>
				<path
					fill="#7F7F7F"
					d="M40.21 69.424c.48 1.231 1.418 4.166-1.215 18.45-1.326 7.177-1.95 8.46-1.77 11.99a27.885 27.885 0 001.742 8.542c.153.518.356.973.518 1.405.163.433.186.636.252.967a11.343 11.343 0 01-9.025 13.244 11.541 11.541 0 01-9.944-2.614 26.45 26.45 0 01-1.947-2.237 19.976 19.976 0 01-4.434-9.821c-.2-1.741-.165-3.501.104-5.233a41.333 41.333 0 011.535-5.276s.794-2.739 1.26-5.393c.464-2.655.283-4.728-.598-10.6-1.264-8.39-1.667-9.772-1.785-11.214 0 0-.072-.62-.052-1.186-.03-3.612 2.154-8.07 2.373-8.527 1.695-3.397 2.343-3.312 4.056-7.04a13.47 13.47 0 001.412-4.068c.442-3.506-1.396-5.042-.532-6.428 1.079-1.73 5.097-1.327 7.646-.39 3.976 1.422 7.313 5.293 6.876 8.114a3.946 3.946 0 01-.83 2.095c-.828.968-1.856.927-2.387 1.946a2.696 2.696 0 00-.24 1.502c.143 1.74 1.549 2.291 3.247 4.407a27.268 27.268 0 013.738 7.365z"
				/>
				<path
					fill="#999"
					d="M43.145 40.672c.196 1.72.234 3.454.115 5.18a29.386 29.386 0 01-.612 3.827 13.455 13.455 0 01-1.387 4.281 4.553 4.553 0 01-1.57 1.861 5.178 5.178 0 01-4.011.151 9.134 9.134 0 01-2.444-1.165c-1.092-.673-1.23-.986-2.46-1.869a23.226 23.226 0 00-2.715-1.65c-2.402-1.293-2.506-.896-3.716-1.696a9.422 9.422 0 01-3.381-4.176 12.846 12.846 0 01-.706-3.29 11.466 11.466 0 0122.876-1.462l.01.008zM47.986 53.074a4.51 4.51 0 014.558 4.464 4.705 4.705 0 01-.726 2.566c-.23.281-.552.666-.87 1.002a13.725 13.725 0 01-2.055 1.8c-1.498 1.063-2.266 1.146-3.607 2.026-1.716 1.06-1.489 1.566-4.102 4.22a43.678 43.678 0 01-5.467 4.722c-.488.337-.95.651-1.363.945l-.045.039c-.607.384-1.163.746-1.598 1.014a6.021 6.021 0 01-2.514.59 6.6 6.6 0 01-6.658-6.574 6.83 6.83 0 011.515-4.45l.052-.045c.436-.383.834-.732 1.193-1.126.027-.01.05-.03.064-.056a22.14 22.14 0 015.187-3.41 46.594 46.594 0 013.341-1.304c1.516-.5 1.745-.484 3.07-.954a18.786 18.786 0 003.732-1.623 14.924 14.924 0 003.175-2.454 4.397 4.397 0 013.118-1.392zM64.186 20.698c-.2-.083-.42-.108-.635-.071-.8.097-1.247.959-1.533.841-.043.002-.053-.05-.108-.141a2.033 2.033 0 00-.799-.826c-.382-.174-.848.167-1.207.394A4.68 4.68 0 0058.5 22.5c-.706 1.265-.508 1.557-1.384 3.801a13.041 13.041 0 00-.66 1.861c-.134.566-.228 1.14-.279 1.719a9.52 9.52 0 00.507 3.63l.003.103c.087.27.18.489.238.675l.003.085c.306.64.834 1.147 1.487 1.425a3.108 3.108 0 004.058-1.684.953.953 0 00.093-.26 15.529 15.529 0 011.881-3.998c.537-.763 1.004-1.318 1.004-1.318.822-.884.976-.89 1.207-1.35a3.646 3.646 0 00-.092-2.56 12.854 12.854 0 00-1.09-2.286c-.48-.982-.78-1.458-1.29-1.645z"
				/>
				<path
					fill="#999"
					d="M57.306 32.185a3.492 3.492 0 014.444 4.604 76.968 76.968 0 01-8.278 21.545 4.364 4.364 0 01-2.447 2.57 4.602 4.602 0 01-5.85-6.06 28.308 28.308 0 013.551-7.954c1.284-1.94 2.129-2.662 3.41-4.632a26.821 26.821 0 003.111-7.124 3.338 3.338 0 012.059-2.95z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2182_17222">
					<path fill="#fff" d="M0 0H90V90H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
